<template>
	<Tooltip placement="top" :title="tooltipTitle">
		<TimeRelative :time="dateObj" />
	</Tooltip>
</template>
<script setup lang="ts">
import { computed } from "vue";
import TimeRelative from "@/components/TimeRelative.vue";
import Tooltip from "@/components/Tooltip.vue";
import { formatDate } from "@/format";

interface Props {
	time: Date | string;
}
const props = defineProps<Props>();

const dateObj = computed<Date>(() => {
	if (props.time instanceof Date) return props.time;
	return new Date(props.time);
});

const tooltipTitle = computed<string>(() => {
	return formatDate(dateObj.value);
});
</script>
